import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { Flex, MenuItem, Text } from "@chakra-ui/react";
import { LocationState } from "~/constants";

type State = Partial<LocationState>;

interface Props {
  children: ReactNode;
  href?: string;
  label?: ReactNode;
  onClick?: () => void;
  state?: State;
  to?: string;
  openInNewTab?: boolean;
}

export const DesktopMenuItem: FC<Props> = ({
  children,
  href,
  label,
  onClick,
  state,
  to,
  openInNewTab,
}) => {
  const linkProps = to ? { as: Link, state, to } : {};
  const anchorProps = href
    ? {
        as: "a" as const,
        href,
        ...(openInNewTab && {
          target: "_blank",
          rel: "noopener noreferrer",
        }),
      }
    : {};
  const props = { ...linkProps, ...anchorProps };

  return (
    <MenuItem onClick={onClick} px={8} {...props}>
      <Flex direction="column">
        <Text color="th.gray4" variant="th-t4">
          {label}
        </Text>
        <Flex align="center" gap={2}>
          {children}
        </Flex>
      </Flex>
    </MenuItem>
  );
};
